<template lang="pug">
router-link.create-button.--base-color.--underline-effect(
  :to="{ name: 'createPost' }"
) create
</template>

<script>
export default {
  name: 'back-button',
}
</script>

<style lang="sass">
.create-button
  display: inline-block
  margin-bottom: 0.5rem
  font-size: 1rem
  font-variant: all-small-caps

  &.--underline-effect
    --underline-effect-line-height: 2px
    background-position: bottom center
</style>
